<template>
  <v-data-table
    :loading="loading"
    :headers="headers"
    :items="itemsByDomain"
    :search="search"
  >
    <template v-slot:item.permissions="{ item }">
      <v-row class="my-0 py-0">
        <v-col class="my-0 py-0"
          v-for="(list, idx) in getPermissionLists(item)"
          :key="idx"
        >
          <simple-list :items="list"/>
        </v-col>
      </v-row>
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="my-3">
        <v-btn
          small
          :id="`groups-table-edit-btn-${item.id}`"
          @click="() => $emit('edit', item)"
          v-if-has-permission:hide="editGroupsPermission"
        >
          Edit Group
        </v-btn>
      </div>
      <div class="my-3">
        <v-btn
          small
          color="error"
          :id="`groups-table-delete-btn-${item.id}`"
          @click="() => $emit('delete', item)"
          v-if-has-permission:hide="deleteGroupsPermission"
        >
          Delete Group
        </v-btn>
      </div>
    </template>
  </v-data-table>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import SimpleList from '@/components/utils/SimpleList';


export default {
  name: 'AdminUsersTable',
  components: {
    SimpleList,
  },
  props: {
    search: String,
  },
  data: () => ({
    items: [],
    headers: [
      { text: 'Group Name', value: 'name' },
      { text: 'Desciption', value: 'description' },
      { text: 'Domain', value: 'domain_name', width: 150 },
      { text: 'Permissions', value: 'permissions' },
      { text: 'Actions', value: 'actions', width: 300 },
    ],
    loading: false,
  }),
  computed: {
    editGroupsPermission: vm => vm.$permissions.EDIT_GROUPS,
    deleteGroupsPermission: vm => vm.$permissions.DELETE_GROUPS,
    roleDomains: vm => vm.$store.getters.role?.domains,
    allowedDomains() {
      return (this.roleDomains || []).map(d => d._id);
    },
    itemsByDomain() {
      return this.items.filter(i => this.allowedDomains.includes(i.domain));
    },
  },
  methods: {
    getPermissionLists(item) {
      const arr = [];
      const chunkSize = 10;
      const permissions = this.$utils.sortIgnoringCase(this.$utils.deepCopy(item.permissions));

      for (let idx = 0; idx < permissions.length; idx += chunkSize) {
        arr.push(permissions.slice(idx, idx + chunkSize));
      }

      return arr;
    },
    fetch() {
      this.loading = true;
      this.$requests.get('/v1/groups?grouped=false')
        .then(response => {
          this.items = response.data;
        })
        .catch(() => {
          this.$toast.error('Could not resolve groups...', { timeout: 3000 });
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
